import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';

import LoginFormComponent from './LoginFormComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

import './LoginModalComponent.scss';

class LoginModalComponent extends React.Component {
    render() {
        const {
            currentPath = PATH.HOME_PATH,
            redirection,
            notRegisteredText,
            registerText,
            LOG_IN,
            dynamicText
        } = this.props;
        return (
            <div className="modal-login-form">
                <h1>{LOG_IN}</h1>
                {dynamicText && <p>{dynamicText}</p>}
                <LoginFormComponent currentPath={redirection || currentPath} />
                <p className="register-link txtcenter">
                    {notRegisteredText}
                    <LocalizedNavLink to={PATH.REGISTER_PATH}>{registerText}</LocalizedNavLink>
                </p>
            </div>
        );
    }
}

LoginModalComponent.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        LOG_IN: state.i18n.page.LOGIN.TITLE,
        notRegisteredText: state.i18n.feature.form.NOT_REGISTERED,
        registerText: state.i18n.page.REGISTER.BUTTON_REGISTER
    };
};

export default connect(mapStateToProps)(LoginModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginModalComponent.js